<template>
  <span @click="passEvent">
    <slot></slot>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRoute } from 'vue-router';

import BGOTrackingServices from '@/services/BGOTrackingServices';
import { log } from '@/lib/Debug';

export default defineComponent({
  name: 'BTrackingClickEvent',

  components: {},

  props: {
    eventId: {
      type: String,
      default: '',
    },
    event: {
      type: String,
      default: '',
    },
    pageInfo: {
      type: Object,
      default: () => ({}),
    },
    clickInfo: {
      type: Object,
      default: () => ({}),
    },
    pageSearchTerm: {
      type: String,
      default: '',
    }
  },

  setup(props) {
    const route = useRoute();
    const passEvent = () => {
      if (process.env.SERVER) {
        return;
      }
      if (!props.event) {
        return;
      }
      const eventInfo: BGOTrackingEvent = {
        eventId: props.eventId,
        event: props.event,
        pageInfo: Object.assign(
          {
            page: 'web_planet_comics_music_home',
            name: '雙星音樂專案',
          },
          props.pageInfo,
        ),
        clickInfo: props.clickInfo,
        pageSearchTerm: props.pageSearchTerm,
      };
      if (Object.keys(eventInfo.clickInfo).length === 0) {
        delete eventInfo.clickInfo;
      }
      if (!props.pageSearchTerm ||props.pageSearchTerm == '') {
        delete eventInfo.pageSearchTerm;
      }
      const event = BGOTrackingServices.createEvent('ClickEvent', eventInfo);
      BGOTrackingServices.passEvent(event);
    };
    return { passEvent };
  },
});
</script>

<style lang="scss" scoped></style>
